import type { FC } from "react";
import { CallState, type ExternalResource } from "@b2bportal/core-types";

export interface ExternalResourceLoaderProps<
  TData,
  TError,
  TExternalResource extends ExternalResource<TData, TError>
> {
  data: TExternalResource;
  notCalled: JSX.Element;
  loading: JSX.Element;
  failed: FC<{ reason: string }>;
  children: (resp: TData) => JSX.Element;
}

export function ExternalResourceLoader<
  TData,
  TError,
  TExternalResource extends ExternalResource<TData, TError>
>(
  props: ExternalResourceLoaderProps<TData, TError, TExternalResource>
): JSX.Element | null {
  const { data, notCalled, failed, loading, children } = props;

  switch (data.state) {
    case CallState.NotCalled:
      return notCalled;
    case CallState.InProcess:
      return loading;
    case CallState.Success:
      return children(data.data);
    case CallState.Failed: {
      console.error("Fetching quote is failed with the reason:", data.error);
      return failed({ reason: String(data.error) });
    }
    default:
      return failed({ reason: "unknown" });
  }
}
